module.exports = __webpack_public_path__ + "img/card-dog-3.c81d9da5.png";